import { msg } from "@lingui/core/macro";
import { Trans, useLingui } from "@lingui/react/macro";
import { Link } from "@tanstack/react-router";

import { Button } from "@/shared/ui/button";

import { useDrillsOverview } from "../../api/useDrillsOverview";

const WAITING = msg({
  message: "{pending, plural, one {# task is waiting} other {# tasks are waiting}}",
});

// «Пока — тренировка по твоим ошибкам»: второе действие карточки «Новых матчей пока нет»
// на главной (макет «15г», `design/prototype/ReturnNoMatches.dc.html`). Задачи ждут —
// их число значком, как у пункта меню.
export const DrillsNowLink = () => {
  const { i18n } = useLingui();
  const { data } = useDrillsOverview();
  const pending = data?.pending ?? 0;
  return (
    <Button asChild size="lg" variant="outline" className="h-11 border-border-strong">
      <Link to="/drills" className="no-underline">
        <Trans>Meanwhile — training on your mistakes</Trans>
        {pending > 0 && (
          <span className="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-accent px-1.5 font-mono text-xs text-accent-foreground">
            <span aria-hidden="true">{pending}</span>
            <span className="sr-only">{i18n._({ ...WAITING, values: { pending } })}</span>
          </span>
        )}
      </Link>
    </Button>
  );
};
